import CertificateTemplateLists from './CertificateTemplateLists'

export default CertificateTemplateLists
